<script lang="ts">
    
    import { onMount } from "svelte";
    import RoomQr from "../../Components/Rooms/RoomQr.svelte";
    import { roomsService } from "../../Services";

    export let roomId: string;

    let textElement: HTMLElement;

    onMount(async () => {
        try {
            const room = await roomsService.getRoom(roomId);
            textElement.textContent = room.name.value;
        } catch (error) {
            console.log(error);
        }
    });

    function onPrint() {
        window.print();
    }

</script>

<div class="room-qr">
    <div class="content">
        <RoomQr {roomId} />
        <div class="text" bind:this={textElement} contenteditable="true"></div>
    </div>

    <button type="button" class="btn btn-secondary print-btn" on:click={onPrint}>
        Imprimir
    </button>
</div>

<style lang="scss">

    .room-qr {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .text {
        text-align: center;
        font-size: 4rem;
    }

    .print-btn {
        position: absolute;
        bottom: 1rem;
        right: 1rem;
    }

    @media print {
        .print-btn {
            display: none;
        }
    }
    

</style>

